module.exports = __webpack_public_path__ + "img/legend.6d80b58e.svg";